export const API_TIMEOUT_MS = 15_000;
export const ATTACHMENT_UPLOAD_TIMEOUT_MS = 120_000;
